// extracted by mini-css-extract-plugin
export default {"optgroup":"optgroup---A8EMA"};